import { render, staticRenderFns } from "./BlockFeaturedArticle.vue?vue&type=template&id=0b79a6fa&scoped=true&"
import script from "./BlockFeaturedArticle.vue?vue&type=script&lang=js&"
export * from "./BlockFeaturedArticle.vue?vue&type=script&lang=js&"
import style0 from "./BlockFeaturedArticle.vue?vue&type=style&index=0&id=0b79a6fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b79a6fa",
  null
  
)

export default component.exports